import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { showToast } from 'src/utils/showToaster';
import ExpenseCategoriesForm from '../Layouts/ExpenseCategoriesForm';
import { useAddExpenseCategoriesMutation } from 'src/services/ExpenseCategoriesService';
import { ExpenseCategoriesFormValues } from 'src/models/ExpenseCategories.model';

type Props = {
    onClose: () => void;
};

const AddExpenseCategoriesWrapper = ({ onClose }: Props) => {
    // Form Initial Values
    const initialValues: ExpenseCategoriesFormValues = {
        expenseCategoryName: '',
    };

    // Validation Schema
    const validationSchema = object().shape({
        expenseCategoryName: string().required('Please enter ExpenseCategories name'),
    });


    const [addExpenseCategory] = useAddExpenseCategoriesMutation()

    // Handle Submit
    const handleSubmit = (
        values: ExpenseCategoriesFormValues,
        { setSubmitting, resetForm }: FormikHelpers<ExpenseCategoriesFormValues>
    ) => {
        addExpenseCategory(values).then((res: any) => {
            if (res?.error) {
                showToast("error", res?.error?.data?.message);
            } else {
                if (res?.data?.status) {
                    showToast("success", res?.data?.message);
                    resetForm()
                    onClose();
                } else {
                    showToast("error", res?.data?.message);
                }
            }
            setSubmitting(false);
        });
    };

    return (
        <Dialog open maxWidth='xs' fullWidth>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form>
                        <ExpenseCategoriesForm formikProps={formikProps} onClose={onClose} formType='ADD' />
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default AddExpenseCategoriesWrapper;